<template>
<div id="index_float_01" style="display:;">
            <div class="part_01">
                <a class="float_hide" title="关闭"></a><a class="float_show" title="展开" style="display: none"></a>
            </div>
            <div class="part_02">
                     
                <a :href="item.type==0?item.url:'javascript:;'" class="telbox" 
                v-for="(item,index) in content" :key="index" target="__blank"
                >
                    <div class="qqbox">
                        <div id="tel_consult" v-if="item.type==1">
                            
                            <img :src="item.url">
                            <div class="arrow"></div>
                        </div>
                        <img :src="item.ico"><br>{{item.name}}
                     </div>
                </a>
            </div>

        </div>
    
</template>
<style scoped src="../../public/css/online.css">
</style>
<script>
export default {
    name:'Consult' ,
     props: {
    content: Array,
  },methods:{
      
  }
}
</script>
